import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-1722">
      <About data-id="element-1723" />
    </main>;
}